import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Group} from '@mantine/core';
import {Link} from 'react-router-dom';
import {ActionCodesService} from '../api/generated/ActionCodesService';
import {BasicPage} from '../components/basic-page';
import {
  usePagedDataTable,
  PagedDataTableConfig,
  renderEditButton,
} from '../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../routes';
import {faCircle} from '@fortawesome/pro-solid-svg-icons';
import {css} from '@emotion/react';

const RuntimeConfig = {
  renderActions: (
    <Button component={Link} to={ROUTES.ADMIN.ACTION_CODES.CREATE.path}>
      <Group gap={'xs'}>
        <FontAwesomeIcon icon={faPlus} /> New Action Code
      </Group>
    </Button>
  ),
};

export const ActionCodeListing = () => {
  const pagedDataTable = usePagedDataTable(
    ActionCodesService.getAll,
    TableConfig,
    {
      ...RuntimeConfig,
    }
  );

  return <BasicPage title="Action Codes">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(ActionCodesService.getAll, {
  columns: [
    {
      accessor: '',
      title: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'Action Code',
          route: ROUTES.ADMIN.ACTION_CODES.DETAIL.path,
        }),
      width: 50,
    },
    {
      accessor: 'description',
      sortable: true,
    },
    {
      accessor: 'requireLot',
      title: 'Required Lot Status',
      render: (item) => (item.requireLot ? 'Yes' : 'No'),
    },
    {
      accessor: 'isDefault',
      title: 'Default Status',
      render: (item) => (item.isDefault ? 'Yes' : 'No'),
    },
    {
      accessor: 'hasClassIdDefaults',
      title: 'Has Class ID Defaults',
      render: (item) => (item.hasClassIdDefaults ? 'Yes' : 'No'),
    },
    {
      accessor: 'dispositionRequirements',
      title: 'Disposition Requirements',
      render: (item) => (item.requireLot ? 'Yes' : 'No'),
    },
    {
      accessor: 'color',
      render: (item) => (
        <FontAwesomeIcon icon={faCircle} color={item.color} css={colorIcon} />
      ),
    },
    {
      accessor: 'sortOrder',
      title: 'Sort Order',
      sortable: true,
    },
    {
      accessor: 'inactive',
      title: 'Status',
      render: (item) => (item.inactive ? 'Inactive' : 'Active'),
    },
  ],
  defaultSort: {
    column: 'sortOrder',
    direction: 'ASC',
  },
  searchFieldNames: ['description'],
});

const colorIcon = css({
  border: '2px solid black',
  borderRadius: '1rem',
});
